import { supabase } from '@/integrations/supabase/client';

export const uploadMessageAttachment = async (
  file: File,
  conversationId: string,
  userId: string
): Promise<{ success: boolean; url?: string; error?: any }> => {
  try {
    // Validate file size (10MB limit for all files)
    if (file.size > 10 * 1024 * 1024) {
      return { success: false, error: "File too large. Maximum size is 10MB" };
    }

    // Create unique filename
    const fileExt = file.name.split('.').pop() || 'bin';
    const fileName = `${conversationId}/${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
    
    // Upload to storage
    const { data, error: uploadError } = await supabase.storage
      .from('avatars')
      .upload(`message-attachments/${fileName}`, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      console.error("Upload failed:", uploadError);
      return { success: false, error: uploadError };
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('avatars')
      .getPublicUrl(`message-attachments/${fileName}`);

    return { success: true, url: publicUrl };
  } catch (error) {
    console.error('Exception during file upload:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Upload failed' 
    };
  }
};

export const validateFile = (file: File): { valid: boolean; error?: string } => {
  if (file.size > 10 * 1024 * 1024) {
    return { valid: false, error: "File too large. Maximum size is 10MB" };
  }
  
  return { valid: true };
};

// Keep the old function for backward compatibility
export const validateImageFile = validateFile;
